export default {
  ONLINE: 'online',
  READY: 'ready',
  STARTED: 'started',
  STOPPED: 'stopped',
  ERROR: 'error',
};
